import { deleteCurrentToken } from 'api/firebase';
import { Links } from 'settings';

export function handleLogout(inviteFlow?: boolean | string) {
  const currentToken = localStorage.getItem('accessToken');
  const currentUser = localStorage.getItem('user');

  if (!currentUser && !currentToken) {
    return;
  }

  deleteCurrentToken();
  localStorage.removeItem('user');
  localStorage.removeItem('expiresAt');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('selectedTeam');
  localStorage.removeItem('webPushToken1');
  localStorage.removeItem('subscription');

  if (window.location.pathname.includes('sign-in') || inviteFlow) {
    return;
  }

  window.location.replace(Links.auth.signIn);
}
